module.exports = __webpack_public_path__ + "static/bed-frame-2-32010c050767708f5fc24e7478337b84.png";